import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { DEPARTMENT_TYPE_PROFESSIONAL } from 'src/app/core/constants';

@Component({
    selector: 'app-professional-attached',
    templateUrl: './professional-attached.component.html',
    styleUrls: ['./professional-attached.component.scss'],
})
export class ProfessionalAttachedComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Profissional
     */
    public departmentType: string = DEPARTMENT_TYPE_PROFESSIONAL;

    /**
     * Definição do parâmetro recebido via url através do menu sidebar
     */
    public sessionType;

    constructor(private route: ActivatedRoute) {
        this.route.params.subscribe((params) => (this.sessionType = params['sessionType']));
    }

    ngOnInit(): void {
        //console.log('sessionType=' + this.sessionType);
    }
}
